import styled, { css, keyframes } from 'styled-components';

const stepEaseIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export default styled.div<{ isDragActive: boolean }>`
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 48px;
  font-family: ${({ theme }) => theme.font.family};
  ${({ theme, isDragActive }) => css`
    cursor: ${isDragActive ? 'grabbing' : 'default'};
    color: ${theme.mainTheme.color.typography.greyText};
    border: 2px dashed ${isDragActive ? theme.mainTheme.color.red.light : theme.mainTheme.color.grey.background};
    background: ${isDragActive ? theme.mainTheme.color.red.lightBackground : theme.mainTheme.color.background};
  `}

  .styled-drag-and-drop-area__step-enter {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 48px;
    animation: ${stepEaseIn} 0.35s ease;
  }

  .styled-drag-and-drop-area__file-header {
    animation: ${stepEaseIn} 0.3s ease;
  }

  .styled-drag-and-drop-area__picture {
    color: ${({ theme }) => theme.mainTheme.color.typography.lightGreyText};

    &-green {
      color: #72CA95;
    }
  }

  .styled-drag-and-drop-area__text-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 8px;
    text-align: center;

    h1 {
      color: ${({ theme }) => theme.mainTheme.color.grey.dark};
    }

    p {
      color: ${({ theme }) => theme.mainTheme.color.typography.greyText};
    }
  }
`;
